import { formatDate } from '@angular/common';
import { AfterViewChecked, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { forkJoin, Observable, Subject, Subscription } from 'rxjs';
import { delay, filter, retryWhen, scan, takeUntil } from 'rxjs/operators';
import { CommonDataService } from '../../../common/services/common-data.service';
import { GraphqlService } from '../../../common/services/graphql.service';
import { HttpcallService } from '../../../common/services/httpcall.service';
import { LoginService } from '../../../common/services/Login.service';
import { OpenLinkById } from '../../../common/services/openlinkbyid';
import { SessionService } from '../../../common/services/Session.service';
import scrollIntoView from 'scroll-into-view-if-needed'

@Component({
  selector: 'app-show-allin-one-page',
  templateUrl: './show-allin-one-page.component.html',
  styleUrls: ['./show-allin-one-page.component.css', '../dita-content/dita-content.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ShowAllinOnePageComponent implements OnInit, OnDestroy, AfterViewChecked {
  sectionHeader: any;
  fillingStatus_Label: any;
  showingContent_Label: any;

  constructor(private router: Router, private route: ActivatedRoute, public commonDataService: CommonDataService, private httpCallService: HttpcallService,
    private openLink: OpenLinkById,
    private graphQLService: GraphqlService, private browserTitle: Title, private session: SessionService, private loginService: LoginService) {
    this.graphQLService.getPreloadContentPage().subscribe(data => { this.preloadContentPage = data; })
  }
  PublPageIds;

  outcome: boolean = false;
  mainsectionsectionname;
  parentlevel: boolean = false;
  s3ImageBasePath: string = "";
  HistoryCrumbData: string = "";
  ASUResponse: any = {};
  pcsIntegratedFlag;
  //annotationCount: any = {};
  //bookmarkCount: any = {};
  previousUrl: string = "";
  event$: Subscription;
  private destroy$: Subject<void> = new Subject<void>();
  ngOnInit(): void {
    this.outcome = false;
    /*this.imageFunctionalityNotCompleted = true;*/
    /*this.pendingContentFunctionalityNotCompleted = true;*/
    this.starting = true;
    this.commonDataService.showLoader.next(true);
    //this.paragraphIdsList = [];
    //this.printqueueAddedList = [];
    this.PublPageIds = [];
    this.PublPageIds = JSON.parse(localStorage.getItem("publpageId"));

    if (this.PublPageIds == null || (this.PublPageIds[0]?.mainsectionname?.split(" ")[0] + "-" + this.PublPageIds[0]?.sectionname?.split(" ")[0] != this.router.url.split("/")[1] + "-" + this.router.url.split("/")[2])) {
      this.checkShowAllInput();
    } else {
      this.loadShowAll();
    }
    this.previousUrl = this.router.url;
    if (localStorage.getItem("isPendingContentPage") == 'true') {
      localStorage.setItem("isShowAllInOnePage", "true");
    }
    //this.graphQLService.getGlobalLabels().subscribe(globalLabels => { this.getActionMenuLabels(globalLabels); });
    this.event$ = this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd)
      )
      .subscribe(() => {
        if (this.previousUrl.split("/")[1] != this.router.url.split("/")[1] || this.previousUrl.split("/")[2] != this.router.url.split("/")[2]) {
          this.previousUrl = this.router.url;
          //this.paragraphIdsList = [];
          //this.printqueueAddedList = [];
          let pubPageIds = JSON.parse(localStorage.getItem("publpageId"));
          if (localStorage.getItem("isPendingContentPage") == 'true') {
            localStorage.setItem("isShowAllInOnePage", "true");
          }
          if ((this.PublPageIds[0]?.mainsectionname?.split(" ")[0] + "-" + this.PublPageIds[0]?.sectionname?.split(" ")[0] != this.router.url.split("/")[1] + "-" + this.router.url.split("/")[2]) || ((this.PublPageIds.length != 0) && (this.PublPageIds.length != pubPageIds.length || this.PublPageIds[0].mainsectionname != pubPageIds[0].mainsectionname || this.PublPageIds[0].sectionname != pubPageIds[0].sectionname))) {
            this.outcome = false;
            this.commonDataService.showLoader.next(true);
            this.AllPageData = {};
            this.ASUResponse = {};
            this.PublPageIds = pubPageIds;
            if (this.PublPageIds == null || (this.PublPageIds[0]?.mainsectionname?.split(" ")[0] + "-" + this.PublPageIds[0]?.sectionname?.split(" ")[0] != this.router.url.split("/")[1] + "-" + this.router.url.split("/")[2])) {
              this.checkShowAllInput();
            } else {
              this.loadShowAll();
            }
          }
        }
      });

    this.commonDataService.displayAllSourcesForPrint.pipe(takeUntil(this.destroy$)).subscribe(data => {
      if (data != null) {
        let article = document.getElementById("printPara");
        if (article != null) {
          let sfragment = article.getElementsByClassName('sfragment') as HTMLCollectionOf<HTMLElement>;
          if (sfragment && sfragment?.length) {
            let sfragmentDataStringNew = "";
            for (let i = 0; i < sfragment?.length; i++) {
              let sfragmentData1 = sfragment[i].getElementsByClassName('sfragment-data');
              for (let j = 0; j < sfragmentData1?.length; j++) {
                let standardName = sfragmentData1[j].getElementsByClassName('sfragment-standard-name');
                let standardNumber = sfragmentData1[j].getElementsByClassName('sfragment-standard-number');
                let paraNumber = sfragmentData1[j].getElementsByClassName('sfragment-para-number');

                if (standardName && standardName?.length && standardNumber && standardNumber?.length) {
                  sfragmentDataStringNew += standardName[0].innerHTML + " " + standardNumber[0]?.innerHTML;
                }
                if (paraNumber && paraNumber?.length) {
                  sfragmentDataStringNew += ", paragraph " + paraNumber[0]?.innerHTML;
                }
                if (sfragmentDataStringNew != "") {
                  sfragmentData1[j].innerHTML = sfragmentDataStringNew;
                }
                sfragmentDataStringNew = "";
              }
            }
          }
          let sfragmentData2 = article.getElementsByClassName('sfragment-data') as HTMLCollectionOf<HTMLElement>;

          if (data.toggleValue) {

            for (let i = 0; i < sfragment.length; i++) {
              sfragment[i].classList.add('show-sources-sfragment');
            }
            for (let i = 0; i < sfragmentData2.length; i++) {
              sfragmentData2[i].classList.add('show-sources-sfragment-data');
              sfragmentData2[i].style.display = 'inline';
            }
          }
          else {

            for (let i = 0; i < sfragment.length; i++) {
              sfragment[i].classList.remove('show-sources-sfragment');
            }
            for (let i = 0; i < sfragmentData2.length; i++) {
              sfragmentData2[i].classList.remove('show-sources-sfragment-data');
              sfragmentData2[i].style.display = 'none';
            }
          }
        }
      }
    });

    this.commonDataService.displayAllSources.pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.displayAllSourcesValue = data;

      if (data != null) {
        const root = document;

        const sfragments = root.querySelectorAll('.sfragment');
        const sfragmentData = root.querySelectorAll('.sfragment-data');

        sfragmentData.forEach((node: Element) => {
          const span = node as HTMLElement;

          const sname = span.querySelector('.sfragment-standard-name')?.textContent?.trim() ?? '';
          const snum = span.querySelector('.sfragment-standard-number')?.textContent?.trim() ?? '';
          const pnum = span.querySelector('.sfragment-para-number')?.textContent?.trim() ?? '';

          let formattedText = '';
          if (sname && snum) {
            formattedText = `${sname} ${snum}`;
          }
          if (pnum) {
            formattedText += `${formattedText ? ', ' : ''}paragraph ${pnum}`;
          }

          if (formattedText) {
            span.innerHTML = formattedText;
          }

          if (data.toggleValue.toString() === 'true') {
            span.classList.add('show-sources-sfragment-data');
            span.style.display = 'inline';
          } else {
            span.classList.remove('show-sources-sfragment-data');
            span.style.display = 'none';
          }
        });

        sfragments.forEach((node: Element) => {
          const fragment = node as HTMLElement;
          if (data.toggleValue.toString() === 'true') {
            fragment.classList.add('show-sources-sfragment');
          } else {
            fragment.classList.remove('show-sources-sfragment');
          }
        });
      }
    });
  }

  displayAllSourcesValue: any;
  //ngAfterViewInit(): void {
  //  //this.addPdfImage();
  //  console.log("Hi")
  //  this.commonDataService.showLoader.next(false);
  //}

  remove(arr, what) {
    arr.sort().forEach(function (value, index) {
      if (value.id === what) {
        arr.splice(index, 1);
      }
    });
  }

  checkShowAllInput() {
    let breadcerumbUrl = "";
    if (this.router.url.split("/")[2] == "showallinonepage") { breadcerumbUrl = this.router.url.split("/")[1] + "-navPath"; }
    else if (this.router.url.split("/")[3] == "showallinonepage") {
      let topic = parseInt(this.router.url.split("/")[1].replace(/[A-Z]/g, ''));
      let subtopic = parseInt(this.router.url.split("/")[2].replace(/[A-Z]/g, ''));
      if (topic == subtopic) {
        breadcerumbUrl = topic + "-navPath";
      }
      else {
        breadcerumbUrl = topic + "-" + subtopic + "-navPath";
      }
    }
    else {
      breadcerumbUrl = this.router.url.split("/")[1] + "/" + this.router.url.split("/")[2]
    }
    this.getBreadcrumbWithNavPathOriginal(breadcerumbUrl);
    this.loadShowAll();
  }

  loadShowAll() {
    let leftNavigation = JSON.parse(localStorage.getItem("leftNavigationMenu"));
    if (leftNavigation == undefined || leftNavigation == null) {
      this.graphQLService.GetBreadcrumbSession(this.PublPageIds[0].sectionarray[0].publid + "/" + this.PublPageIds[0].sectionarray[0].pageid).subscribe(data => {
        this.crumbData = JSON.parse(JSON.stringify(data)).crumbData;
        this.postBreadcrumbData(this.crumbData)
      });
    }
    else {
      this.getBreadcrumb(this.PublPageIds);
      this.postBreadcrumbData(this.crumbData)
    }
    //this.getPrintSession();
    this.loadAllPages();
  }

  //paragraphIdsList: any[] = [];
  //printqueueAddedList: any[] = [];
  //addedparagraphList = [];
  //getPrintSession() {
  //  this.addedparagraphList = [];
  //  this.paragraphIdsList = [];
  //  this.printqueueAddedList = [];
  //  let printQueueData = JSON.parse(localStorage.getItem("SetPrintQueueSession"));
  //  if (printQueueData) {
  //    if (printQueueData != null && printQueueData.ParagraphIdsList != null) {
  //      this.addedparagraphList = printQueueData.ParagraphIdsList;
  //      this.paragraphIdsList = printQueueData.ParagraphIdsList;
  //      this.printqueueAddedList = printQueueData.printQueueAddedList;
  //    }
  //  }
  //}

  ngOnDestroy() {
    this.PublPageIds = [];
    this.AllPageData = {};
    this.destroy$.next();
    this.destroy$.complete();
    if (this.event$ != undefined) {
      this.event$.unsubscribe();
    }
    if (this.labels$ != undefined) {
      this.labels$.unsubscribe();
    }
    if (this.integratedFlag$ != undefined) {
      this.integratedFlag$.unsubscribe();
    }
    if (this.mainCalls$ != undefined) {
      this.mainCalls$.unsubscribe();
    }
    this.outcome = false;
    sessionStorage.removeItem('inPageScrollPositionRetentionData');
    sessionStorage.removeItem('inPageScrollCurrentNum');
    sessionStorage.removeItem('inPageScrollLastUrl');
  }
  ShowSecContent: boolean = true;
  //imageFunctionalityNotCompleted: boolean = true;
  //pendingContentFunctionalityNotCompleted: boolean = true;
  ngAfterViewChecked() {
    if (localStorage.getItem("DefaultSecView") == "false") {
      this.ShowSecContent = false;
    }
    else {
      this.ShowSecContent = true;
    }
    /*setTimeout(() => {*/
    if (/*this.imageFunctionalityNotCompleted && */document.getElementsByClassName("img").length > 0) {
      /*this.imageFunctionalityNotCompleted = false;*/
      if (!this.preloadContentPage.includes(this.router.url.split("/")[1])) {
        this.addImage();
      }
    }
    if (/*this.pendingContentFunctionalityNotCompleted && */document.getElementsByClassName("pending-text").length > 0) {
      /*this.pendingContentFunctionalityNotCompleted = false;*/
      this.addPendingContent();
    }

    if (this.displayAllSourcesValue != null) {
      this.formatSources(this.displayAllSourcesValue)
    }
    /*}, 500);*/
    if (this.preloadContentPage.includes(this.router.url.split("/")[1])) {
      if (document.getElementsByClassName("img").length > 0 && this.starting) {
        let ImageDivs = document.getElementsByClassName("img") as HTMLCollectionOf<HTMLImageElement>;
        if (ImageDivs.length > 0) {
          this.starting = false;
          let self = this;
          for (let i = 0; i < ImageDivs.length; i++) {
            let hasStyle = ImageDivs[i].getAttribute("style");
            if (hasStyle == null) {
              ImageDivs[i].onload = function () {
                let dimension = { "src": ImageDivs[i].src, "width": ImageDivs[i].naturalWidth.toString(), "height": ImageDivs[i].naturalHeight.toString() };
                self.ImageDimension.push(dimension);
              }
            }
          }
        }
      }
    }

    if (this.singleHttpCall && document.getElementsByClassName("img").length == this.ImageDimension.length && document.getElementsByClassName("img").length > 0) {
      this.singleHttpCall = false;
      this.graphQLService.setImageDimesionsToCache(this.ImageDimension).subscribe(data => { console.log(data) });
    }
  }

  formatSources(data: any)
  {
    const sFragments = document.querySelectorAll<HTMLElement>('.sfragment');
    const show = data.toggleValue?.toString() == "true";

    sFragments.forEach(fragment => {

      if (fragment.classList.contains('formatted')) return;

      const sFragmentDataList = fragment.querySelectorAll<HTMLElement>('.sfragment-data');

      sFragmentDataList.forEach(sData => {
        const name = sData.querySelector('.sfragment-standard-name')?.textContent?.trim() || '';
        const number = sData.querySelector('.sfragment-standard-number')?.textContent?.trim() || '';
        const para = sData.querySelector('.sfragment-para-number')?.textContent?.trim() || '';

        let combined = '';

        if (name && number) {
          combined = `${name} ${number}`;
        }

        if (para) {
          combined += `${combined ? ', ' : ''}paragraph ${para}`;
        }

        if (combined) sData.textContent = combined;

        sData.classList.toggle(`show-sources-sfragment-data`, show);
        sData.style.display = show ? 'inline' : 'none';
      })

      fragment.classList.toggle('show-sources-sfragment', show);
      fragment.classList.add('formatted');

    });

    //let sfragment = document.getElementsByClassName('sfragment') as HTMLCollectionOf<HTMLElement>;
    //if (sfragment && sfragment?.length) {
    //  for (let i = 0; i < sfragment?.length; i++) {
    //    if (!sfragment[i].classList.contains("formatted")) {
    //      let sfragmentData = sfragment[i].getElementsByClassName('sfragment-data') as HTMLCollectionOf<HTMLElement>;
    //      for (let j = 0; j < sfragmentData?.length; j++) {

    //        let sfragmentDataStringNew = "";
    //        let standardName = sfragmentData[j].getElementsByClassName('sfragment-standard-name');
    //        let standardNumber = sfragmentData[j].getElementsByClassName('sfragment-standard-number');
    //        let paraNumber = sfragmentData[j].getElementsByClassName('sfragment-para-number');

    //        if (standardName && standardName?.length && standardNumber && standardNumber?.length) {
    //          sfragmentDataStringNew += standardName[0].innerHTML + " " + standardNumber[0]?.innerHTML;
    //        }
    //        if (paraNumber && paraNumber?.length) {
    //          sfragmentDataStringNew += ", paragraph " + paraNumber[0]?.innerHTML;
    //        }
    //        if (sfragmentDataStringNew != "") {
    //          sfragmentData[j].innerHTML = sfragmentDataStringNew;
    //        }
    //        if (data.toggleValue.toString() == "true") {
    //          sfragmentData[j].classList.add('show-sources-sfragment-data');
    //          sfragmentData[j].style.display = 'inline';
    //        }
    //        else {
    //          sfragmentData[j].classList.remove('show-sources-sfragment-data');
    //          sfragmentData[j].style.display = 'none';
    //        }
    //      }
    //      if (data.toggleValue.toString() == "true") {
    //        sfragment[i].classList.add('show-sources-sfragment');
    //      }
    //      else {
    //        sfragment[i].classList.remove('show-sources-sfragment');
    //      }
    //      sfragment[i].classList.add('formatted');
    //    }
    //  }
    //}
  }


  singleHttpCall: boolean = true;
  ImageDimension: any[] = [];
  starting: boolean = true;

  PendingContentPage: boolean = false;
  FiscalDate: any;
  PeriodType: string;
  fillingStatus: string;
  periodTypeLabel: any;
  PendingContentMergeList: any[];
  isPendingContentIntegrated: boolean = false;
  loadPendingDataForContentPage(resultPendingContent) {
    this.isPendingContentIntegrated = resultPendingContent == false ? false : true;
    if (resultPendingContent.isPCSIntegrated) {
      this.getPCSLabels();
      this.PendingContentPage = resultPendingContent.isPCSIntegrated;
      localStorage.setItem("isPendingContentPage", String(this.PendingContentPage));
      this.FiscalDate = "Fiscal year beginning " + formatDate(resultPendingContent.date, 'MM/dd/yyyy', 'en-US');
      this.fillingStatus = resultPendingContent.filingStatus;
      this.PeriodType = resultPendingContent.periodtype;
      if (resultPendingContent.pcsIntegrationData != null && resultPendingContent.pcsIntegrationData.length > 0) {
        this.PendingContentMergeList = resultPendingContent.pcsIntegrationData;
      }
    }

  }
  labels$: Subscription;
  getPCSLabels() {
    this.labels$ = this.graphQLService.getPendingContentSystemLabels().subscribe(data => {
      if (data != "") {
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.sectionHeader = labels.filter(x => x.key == "pc_contentheader").map(y => y.value);
        this.periodTypeLabel = labels.filter(x => x.key == "pc_periodType").map(y => y.value);
        this.fillingStatus_Label = labels.filter(x => x.key == "pc_filingStatus").map(y => y.value);
        this.showingContent_Label = labels.filter(x => x.key == "pc_Showingcontent_label").map(y => y.value);
      }
    });
  }
  EditPCS() {
    let PCS = { fillingStatus: this.fillingStatus, periodType: this.PeriodType, Date: this.FiscalDate.split("Fiscal year beginning ")[1] };
    localStorage.setItem("PCSInput", JSON.stringify(PCS));
    this.commonDataService.EditFromContentPage.next(true);
    localStorage.removeItem("backlabel");
    localStorage.removeItem("backUrl");
    this.router.navigateByUrl("/pendingcontentsystem");
  }

  preloadContentPage: string[] = [];
  integratedFlag$: Subscription;
  ResetPCS() {
    this.integratedFlag$ = this.graphQLService.SetPCSIntegratedFlag(false).subscribe(data => {
      this.PendingContentPage = false;
      localStorage.setItem("isPendingContentPage", String(this.PendingContentPage));
      this.PendingContentMergeList = [];
      this.reloadCurrentRoute()
    })

  }
  reloadCurrentRoute() {
    const currentUrl = this.router.url;
    this.router.navigateByUrl('/#', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }
  mainCalls$: Subscription;
  loadAllPages() {
    //if (this.crumbData.length == 4) { this.HistoryCrumbData = this.crumbData.slice(0, 1).join("~"); } else { this.HistoryCrumbData = this.crumbData.slice(0, 1).join("~"); }
    this.HistoryCrumbData = this.crumbData.slice(0, 1).join("~");
    let showAllPath: string = "";
    let allPagesHeader: any = [];
    let allHistoryHeader: any = [];
    let allRelatedPASUs: any = [];
    let pageHeaderList: any = [];
    if (this.PublPageIds.length == 1) { showAllPath = this.PublPageIds[0].mainsectionname.split(" ")[0] + "-" + this.PublPageIds[0].sectionname.split(" ")[0]; }
    else if (this.PublPageIds.length > 1) { showAllPath = this.PublPageIds[0].mainsectionname.split(" ")[0]; }
    for (let j = 0; j < this.PublPageIds.length; j++) {
      for (let i = 0; i < this.PublPageIds[j].sectionarray.length; i++) {
        let PageHeader = { "publicationId": this.PublPageIds[0].sectionarray[0].publid, "pageIds": this.PublPageIds[j].sectionarray[i].pageid, "navPath": this.PublPageIds[j].sectionarray[i].pagetitle, "pageName": this.PublPageIds[j].sectionarray[i].pageName };
        let historyHeader = { "BreadCrumb": this.HistoryCrumbData + "~" + this.PublPageIds[j].mainsectionname + "~" + this.PublPageIds[j].sectionname + "~" + this.PublPageIds[j].sectionarray[i].pageName, "NavPath": this.PublPageIds[j].sectionarray[i].pagetitle, "PageURL": this.PublPageIds[0].sectionarray[0].publid + "/" + this.PublPageIds[j].sectionarray[i].pageid };
        let relatedProposedASU = { "topicId": this.PublPageIds[j].sectionarray[i].pagetitle.split("-")[0], "subTopicId": this.PublPageIds[j].sectionarray[i].pagetitle.split("-")[1], "sectionId": this.PublPageIds[j].sectionarray[i].pagetitle.split("-")[2] };
        allPagesHeader.push(PageHeader);
        pageHeaderList.push(PageHeader);
        allHistoryHeader.push(historyHeader);
        allRelatedPASUs.push(relatedProposedASU);
      }
    }
    if (this.PublPageIds.length != 1) {
      this.parentlevel = true;
    }

    this.mainsectionsectionname = this.PublPageIds[0].mainsectionname;
    if (this.session.userInfo == undefined || this.session.userInfo == null) {
      this.loginService.getSession().subscribe(loginData => {
        if (loginData != null) {
          this.loggedInUserInfo = loginData;
          let showAllInOnePageHeader = { "showAllPagePath": showAllPath, "allPagesHeaderList": allPagesHeader, "includeSharedSubtopic": this.router.url.includes("showallinonepageplus") ? true : false }
          let saveHistoryHeader = { "Id": "-1", "UpdateUserId": "", "ApplicationSource": "FASB", "CreateDate": "", "UpdateDate": "", "allHistoryHeader": allHistoryHeader };
          //let paragraphActionInputBody = { NavigationPath: showAllPath, UserId: this.loggedInUserInfo.user.email, Application: "" };
          this.mainCalls$ = forkJoin([this.graphQLService.getS3BucketImagePath(),
          this.graphQLService.getShowAllPageData(showAllInOnePageHeader).pipe(this.handleRetry),
          this.graphQLService.GetPendingContentMergeListforShowAllinOnePage(pageHeaderList)])
            .subscribe(([s3ImagePath, pageData, mergeList]) => {
              this.s3ImageBasePath = s3ImagePath;
              this.AllPageData = pageData;
              this.loadPendingDataForContentPage(mergeList);
              this.outcome = true;
              this.graphQLService.getAllRelatedpropsedASU(allRelatedPASUs).subscribe(asuResponse => {
                this.ASUResponse = asuResponse;
              });

              //if (this.session.globallablesinfo == null || this.session.globallablesinfo == undefined) {
              //  this.graphQLService.getGlobalLabels().subscribe(globalLabels => { this.getActionMenuLabels(globalLabels); });
              //}
              //else { this.getActionMenuLabels(this.session.globallablesinfo); }
              if (this.loggedInUserInfo.user.roles != "Basic") {
                //  this.httpCallService.getBookmarkCount(paragraphActionInputBody).subscribe(bookmarkCount => { this.bookmarkCount = bookmarkCount; })
                //  this.httpCallService.getAnnotationCount(paragraphActionInputBody).subscribe(annotationCount => { this.annotationCount = annotationCount; })
                this.httpCallService.addAllHistory(saveHistoryHeader).subscribe(historyResponse => { console.log(historyResponse); })
              }
              //else {
              //  this.graphQLService.getAllRelatedpropsedASU(allRelatedPASUs).subscribe(asuResponse => { this.ASUResponse = asuResponse; })
              //}
              this.commonDataService.showLoader.next(false);
              //this.imageFunctionalityNotCompleted = true;
              //this.pendingContentFunctionalityNotCompleted = true;
              this.starting = true;
            }, err => {
              console.log(err);
              this.commonDataService.showLoader.next(false);
            });
        }
      });
    }
    else {
      this.loggedInUserInfo = this.session.userInfo;
      let showAllInOnePageHeader = { "showAllPagePath": showAllPath, "allPagesHeaderList": allPagesHeader, "includeSharedSubtopic": this.router.url?.includes("showallinonepageplus") ? true : false }
      let saveHistoryHeader = { "Id": "-1", "UpdateUserId": "", "ApplicationSource": "FASB", "CreateDate": "", "UpdateDate": "", "allHistoryHeader": allHistoryHeader };
      //let paragraphActionInputBody = { NavigationPath: showAllPath, UserId: this.session.userInfo.user.email, Application: "" };
      this.mainCalls$ = forkJoin([this.graphQLService.getS3BucketImagePath(),
      this.graphQLService.getShowAllPageData(showAllInOnePageHeader).pipe(this.handleRetry),
      this.graphQLService.GetPendingContentMergeListforShowAllinOnePage(pageHeaderList)])
        .subscribe(([s3ImagePath, pageData, mergeList]) => {
          this.loggedInUserInfo = this.session.userInfo;
          this.s3ImageBasePath = s3ImagePath;
          this.AllPageData = pageData;
          this.loadPendingDataForContentPage(mergeList);
          this.outcome = true;
          this.graphQLService.getAllRelatedpropsedASU(allRelatedPASUs).subscribe(asuResponse => {
            this.ASUResponse = asuResponse;
          });

          //if (this.session.globallablesinfo == null || this.session.globallablesinfo == undefined) {
          //  this.graphQLService.getGlobalLabels().subscribe(globalLabels => { this.getActionMenuLabels(globalLabels); });
          //}
          //else { this.getActionMenuLabels(this.session.globallablesinfo); }
          if (this.loggedInUserInfo.user?.roles != "Basic") {
            //this.httpCallService.getBookmarkCount(paragraphActionInputBody).subscribe(bookmarkCount => { this.bookmarkCount = bookmarkCount; })
            //this.httpCallService.getAnnotationCount(paragraphActionInputBody).subscribe(annotationCount => { this.annotationCount = annotationCount; })
            this.httpCallService.addAllHistory(saveHistoryHeader).subscribe(historyResponse => { console.log(historyResponse); })
          }
          //else {
          //this.graphQLService.getAllRelatedpropsedASU(allRelatedPASUs).subscribe(asuResponse => { this.ASUResponse = asuResponse; });
          //}
          this.commonDataService.showLoader.next(false);
          //this.imageFunctionalityNotCompleted = true;
          //this.pendingContentFunctionalityNotCompleted = true;
          this.starting = true;
        }, err => {
          console.log(err);
          this.commonDataService.showLoader.next(false);
        });
    }
  }

  private handleRetry<T>(source: Observable<T>): Observable<T> {
    return source.pipe(retryWhen(e => e.pipe(scan((errorCount, error) => {
      if (errorCount >= 3) {
        throw error;
      }
      return errorCount + 1;
    }, 0),
      delay(1000)
    )));
  }

  AllPageData: any = {};
  loggedInUserInfo;
  menuListItems: any = [];
  //getActionMenuLabels(data) {
  //  this.menuListItems = [];
  //  if (data != "") {
  //    var labels = data.content.data.labels;
  //    labels = labels.filter(x => x.key.trim());
  //    if (this.loggedInUserInfo.user.roles != "Basic") {
  //      this.menuListItems.push(labels.filter(x => x.key == "addBookmark_header").map(y => y.value)[0]);
  //      this.menuListItems.push(labels.filter(x => x.key == "addAnnotation_header").map(y => y.value)[0]);
  //    }
  //    this.menuListItems.push(labels.filter(x => x.key == "provideFeedback_header").map(y => y.value)[0]);
  //    this.menuListItems.push(labels.filter(x => x.key == "seeXBRLElements_Header").map(y => y.value)[0]);
  //    this.menuListItems.push(labels.filter(x => x.key == "print_addToQueue").map(y => y.value)[0]);
  //  }
  //}

  breadcrumbPath
  postBreadcrumbData(crumbData) {
    this.commonDataService.navDataContentPage.next(crumbData);
    this.breadcrumbPath = crumbData.join("~");
    //this.commonDataService.breadcrumbPath.next(this.breadcrumbPath);

    var urlSections = this.router.url.split("/");
    let title = "";
    if (urlSections.length == 3) {
      title = this.PublPageIds[0].mainsectionname;
    }
    else {
      title = crumbData[1].includes("X") ? crumbData[2].substring(0, 3) + "-" + crumbData[3] : crumbData[1].substring(0, 3) + "-" + crumbData[2];
    }
    this.browserTitle.setTitle("Combine Sections - " + title);
  }

  crumbData;
  getBreadcrumb(pagepublId: any) {
    let leftNavigation = JSON.parse(localStorage.getItem("leftNavigationMenu"));
    for (let i = 0; i < leftNavigation.length; i++) {
      this.crumbData = [];
      if (leftNavigation[i].itemData != null) {
        for (let j = 0; j < leftNavigation[i].itemData.length; j++) {
          if (leftNavigation[i].itemData[j].itemData != null) {
            for (let k = 0; k < leftNavigation[i].itemData[j].itemData.length; k++) {
              if (leftNavigation[i].itemData[j].itemData[k].itemData != null) {
                for (let l = 0; l < leftNavigation[i].itemData[j].itemData[k].itemData.length; l++) {
                  if (leftNavigation[i].itemData[j].itemData[k].itemData[l].itemLink != null) {
                    if (leftNavigation[i].itemData[j].itemData[k].itemData[l].itemLink == pagepublId[0].sectionarray[0].publid + "/" + pagepublId[0].sectionarray[0].pageid) {
                      this.crumbData.push(leftNavigation[i].item);
                      this.crumbData.push(leftNavigation[i].itemData[j].item);
                      this.crumbData.push(leftNavigation[i].itemData[j].itemData[k].item);
                      this.crumbData.push(leftNavigation[i].itemData[j].itemData[k].itemData[l].item);
                      return;
                    }
                  }
                  else {
                    if (leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData != null) {
                      for (let m = 0; m < leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData.length; m++) {
                        if (leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData[m].itemLink == pagepublId[0].sectionarray[0].publid + "/" + pagepublId[0].sectionarray[0].pageid) {
                          this.crumbData.push(leftNavigation[i].item);
                          this.crumbData.push(leftNavigation[i].itemData[j].item);
                          this.crumbData.push(leftNavigation[i].itemData[j].itemData[k].item);
                          this.crumbData.push(leftNavigation[i].itemData[j].itemData[k].itemData[l].item);
                          this.crumbData.push(leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData[m].item);
                          return;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  getBreadcrumbWithNavPathOriginal(breadcerumbUrl) {
    breadcerumbUrl = breadcerumbUrl.replace("-navPath", "");
    let leftNavigation = JSON.parse(localStorage.getItem("leftNavigationMenu"));
    for (let i = 0; i < leftNavigation.length; i++) {
      if (leftNavigation[i].itemData != null && leftNavigation[i].itemData.length > 0) {
        for (let j = 0; j < leftNavigation[i].itemData.length; j++) {
          if (leftNavigation[i].itemData[j]?.navPath?.startsWith(breadcerumbUrl)) {
            this.mainsection = leftNavigation[i].itemData[j].item;
            if (this.mainsection.split(" ")[0].includes("X")) {
              this.mainsection = leftNavigation[i].itemData[j].item;
            }
            this.showAllInOnePage(leftNavigation[i].itemData[j]);
            return;
          } else {
            if (leftNavigation[i].itemData[j].itemData != null) {
              for (let k = 0; k < leftNavigation[i].itemData[j].itemData.length; k++) {
                if (leftNavigation[i].itemData[j].itemData[k]?.navPath?.startsWith(breadcerumbUrl)) {
                  this.mainsection = leftNavigation[i].itemData[j].item;
                  if (this.mainsection.split(" ")[0].includes("X")) {
                    this.mainsection = leftNavigation[i].itemData[j].itemData[k].item;
                  }
                  this.showAllInOnePage(leftNavigation[i].itemData[j].itemData[k]);
                  return;
                } else {
                  if (leftNavigation[i].itemData[j].itemData[k].itemData != null) {
                    for (let l = 0; l < leftNavigation[i].itemData[j].itemData[k].itemData.length; l++) {
                      if (leftNavigation[i].itemData[j].itemData[k].itemData[l]?.navPath?.startsWith(breadcerumbUrl)) {
                        this.mainsection = leftNavigation[i].itemData[j].itemData[k].item;
                        if (this.mainsection.split(" ")[0].includes("X")) {
                          this.mainsection = leftNavigation[i].itemData[j].itemData[k].itemData[l].item;
                        }
                        this.showAllInOnePage(leftNavigation[i].itemData[j].itemData[k].itemData[l]);
                        return;
                      }
                      else {
                        if (leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData != null) {
                          for (let m = 0; m < leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData.length; m++) {
                            if (leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData[m]?.navPath?.startsWith(breadcerumbUrl)) {
                              this.mainsection = leftNavigation[i].itemData[j].itemData[k].itemData[l].item;
                              if (this.mainsection.split(" ")[0].includes("X")) {
                                this.mainsection = leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData[m].item;
                              }
                              this.showAllInOnePage(leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData[m]);
                              return;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return
  }

  mainsection: string = "";
  pagepubllist: { sectionarray: object[], sectionname: string, mainsectionname: string }[] = [];
  pagepublicationId: { publid: string, pageid: string, pagetitle: string, pageurl: any, pageName: string }[] = [];
  showAllInOnePage(obj) {
    this.pagepublicationId = [];
    this.pagepubllist = [];
    this.getpagepublids(obj);
    this.PublPageIds = this.pagepubllist;
    localStorage.setItem("publpageId", JSON.stringify(this.pagepubllist));
  }
  getpagepublids(obj) {
    if (obj.itemData != null) {
      for (let items of obj.itemData) {
        this.getpagepublids(items);
        if (!this.router.url.includes("showallinonepageplus")) {
          if (items.afterShowAllInOnePageRequired) {
            break;
          }
        }
      }
    }
    if (obj.itemLink != null) {
      if (obj.itemLink.length > 0) {
        let PublpageId = obj.itemLink.split('/').map(d => d);
        let navPath = obj.navPath;
        let navPathSplited = navPath.split("-")
        if (navPathSplited[0].includes("X")) {
          navPathSplited = navPathSplited.slice(1, navPathSplited.length);
        }
        let pageTitle = navPathSplited.join("-");
        if (!navPathSplited[navPathSplited.length - 1].includes("75")) {
          this.pagepublicationId.push({ publid: PublpageId[0], pageid: PublpageId[1], pagetitle: pageTitle, pageurl: obj.itemLink, pageName: obj.item });
        }
      }
    }
    else {
      if (this.pagepublicationId.length > 0) {

        this.pagepubllist.push({ sectionarray: this.pagepublicationId, sectionname: obj.item, mainsectionname: this.mainsection });
        this.pagepublicationId = [];
      }
    }
  }

  OpenRelatedContent(pageTitle) {
    this.commonDataService.ASUParams.next(pageTitle);
    this.commonDataService.showRightPanel.next(true);
    this.commonDataService.rightPanelWidth.next("rightOverlay_large");
    this.commonDataService.rightOverlayOption.next("Related praposed asus");
  }


  onRightClickGeneralNote(event: any) {
    if (event.srcElement.tagName.toLowerCase() == "a" && event.srcElement.className.toLowerCase() == "xref") {
      let ahref = event.srcElement.innerText;
      if (ahref.includes("(")) { ahref = ahref.split("(")[0]; }
      if (ahref.includes("[")) { ahref = ahref.split("[")[0]; }
      if (ahref.includes("to")) { ahref = ahref.split(" to")[0]; }
      if (ahref.includes("through")) { ahref = ahref.split(" through")[0]; }
      if (ahref.includes("-") && ahref.split("-").length >= 2) {
        let navPath = ahref.split("-");
        let url = this.getBreadcrumbWithNavPath(navPath[0] + "-" + navPath[1] + "-" + navPath[2]);
        event.srcElement.setAttribute("href", "/" + url + "/" + ahref);
      }
      else {
        if (ahref.toLowerCase().trim() == 'about the codification' && event?.currentTarget?.classList?.contains('generalNote')) {
          event.srcElement.setAttribute("href", "/" + 'about-us');

        } else {
          let otherSourceUrlParts = event.target.getAttribute('href').split("/");
          let otherSourceUrlLastPart = event.target.getAttribute('href').includes('#') ? event.target.getAttribute('href').split('#')[1] : otherSourceUrlParts[otherSourceUrlParts.length - 1];
          event.srcElement.setAttribute("href", "/" + otherSourceUrlParts[1] + "/" + otherSourceUrlParts[2] + "/" + otherSourceUrlLastPart);
        }
      }
    }
  }

  onContentRightClick(event: any) {
    if (event.srcElement.tagName.toLowerCase() == "a" && event.srcElement.className.toLowerCase().includes("xref") && !event.target.className.includes("term")) {
      let ahref = event.srcElement.innerText;
      if (ahref.includes("(")) { ahref = ahref.split("(")[0]; }
      if (ahref.includes("[")) { ahref = ahref.split("[")[0]; }
      if (!ahref.toLocaleLowerCase().includes("notice to constituents")) {
        if (ahref.includes("to")) { ahref = ahref.split(" to")[0]; }
      }
      if (ahref.includes("through")) { ahref = ahref.split(" through")[0]; }
      if (isNaN(Number(ahref.split("-")[0])) && !ahref.toLocaleLowerCase().includes("notice to constituents") && !ahref.toLocaleLowerCase().includes("maintenance update") && !ahref.toLocaleLowerCase().includes("accounting standards update") && !ahref.toLocaleLowerCase().includes("paragraph not used") && !ahref.toLocaleLowerCase().includes("subsection")) {
        return false;
      }
      else if (ahref.toLocaleLowerCase().includes("maintenance update") || ahref.toLocaleLowerCase().includes("accounting standards update") || ahref.toLocaleLowerCase().includes(("section")) || ahref.toLocaleLowerCase().includes("subsection")) {
        let otherSourceUrlParts = event.target.getAttribute('href').split("/");
        let otherSourceUrlLastPart = event.target.getAttribute('href').includes('#') ? event.target.getAttribute('href').split('#')[1] : otherSourceUrlParts[otherSourceUrlParts.length - 1];
        event.srcElement.setAttribute("href", "/" + otherSourceUrlParts[1] + "/" + otherSourceUrlParts[2] + "/" + otherSourceUrlLastPart);
      }
      else if (ahref.toLocaleLowerCase().includes("notice to constituents") || ahref.toLocaleLowerCase().includes("paragraph not used")) {
        let otherSourceUrlParts = event.target.getAttribute('href').split("/");
        event.srcElement.setAttribute("href", "/" + otherSourceUrlParts[1] + "/" + otherSourceUrlParts[2] + "/noticeToConstituents");
      }
      else if (ahref.includes("-") && ahref.split("-").length >= 2) {
        let navPath = event.target.innerText.split("-");
        let url = this.getBreadcrumbWithNavPath(navPath[0] + "-" + navPath[1] + "-" + navPath[2]);
        event.srcElement.setAttribute("href", "/" + url + "/" + ahref);
      }
      else {
        let otherSourceUrlParts = event.target.getAttribute('href').split("/");
        let navPathUrl: string = this.getBreadcrumbWithNavPath(ahref.split("-")[0] + "-" + ahref.split("-")[1] + "-" + ahref.split("-")[2]);
        let otherSourceUrlLastPart = event.target.getAttribute('href').includes('#') ? event.target.getAttribute('href').split('#')[1] : otherSourceUrlParts[otherSourceUrlParts.length - 1];
        event.srcElement.setAttribute("href", "/" + navPathUrl.split("/")[0] + "/" + navPathUrl.split("/")[1] + "/" + otherSourceUrlLastPart);
      }
    }
    else if (event.target.className.includes("term")) {
      event.srcElement.parentElement.removeAttribute("href");
      event.srcElement.parentElement.className = event.srcElement.parentElement.className.includes("cursor-pointer") ? event.srcElement.parentElement.className : event.srcElement.parentElement.className + " cursor-pointer";
    }
  }

  mouseOverFunctionsGeneralNote(event: any) {
    if (event.srcElement.tagName.toLowerCase() == "a" && event.srcElement.className.toLowerCase() == "ditamap") {
      let ahref = event.srcElement.innerText;
      let navPath = ahref.split("-");
      if (navPath.length >= 3) {
        this.graphQLService.getNavPathTree(navPath[0] + "-" + navPath[1] + "-" + navPath[2]).subscribe(data => { event.srcElement.setAttribute("href", "/" + data[0].itemLink.split("/")[0] + "/" + data[0].itemLink.split("/")[1] + "/" + ahref); });
      }
      else {
        event.srcElement.setAttribute("href", "/" + ahref + "/tableOfContent");
      }
    }
  }


  getBreadcrumbWithNavPath(breadcerumbUrl) {
    let navPathUrl = "";
    let tempData = JSON.parse(localStorage.getItem("leftNavigationMenu"));
    for (let i = 8; i >= 0; i--) {
      if (tempData[i].itemData != null) {
        for (let j = 0; j < tempData[i].itemData.length; j++) {
          if (tempData[i].itemData[j]?.navPath?.startsWith(breadcerumbUrl)) {
            navPathUrl = tempData[i].itemData[j]?.itemLink;
            return navPathUrl;
          } else {
            if (tempData[i].itemData[j].itemData != null) {
              for (let k = 0; k < tempData[i].itemData[j].itemData.length; k++) {
                if (tempData[i].itemData[j].itemData[k]?.navPath?.startsWith(breadcerumbUrl)) {
                  navPathUrl = tempData[i].itemData[j].itemData[k]?.itemLink;
                  return navPathUrl;
                } else {
                  if (tempData[i].itemData[j].itemData[k].itemData != null) {
                    for (let l = 0; l < tempData[i].itemData[j].itemData[k].itemData.length; l++) {
                      if (tempData[i].itemData[j].itemData[k].itemData[l]?.navPath?.startsWith(breadcerumbUrl)) {
                        navPathUrl = tempData[i].itemData[j].itemData[k].itemData[l]?.itemLink;
                        return navPathUrl;
                      }
                      else {
                        if (tempData[i].itemData[j].itemData[k].itemData[l].itemData != null) {
                          for (let m = 0; m < tempData[i].itemData[j].itemData[k].itemData[l].itemData.length; m++) {
                            if (tempData[i].itemData[j].itemData[k].itemData[l].itemData[m]?.navPath?.startsWith(breadcerumbUrl)) {
                              navPathUrl = tempData[i].itemData[j].itemData[k].itemData[l].itemData[m]?.itemLink;
                              return navPathUrl;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return "";
  }

  openLinkByIdGeneralNote(event) {
    this.openLink.linkClicked(event);
  }


  onRightClick(event: any) {
    if (event.srcElement.tagName.toLowerCase() == "a" && event.srcElement.className.toLowerCase().includes("xref") && !event.target.className.includes("term")) {
      let ahref = event.srcElement.innerText;
      if (ahref.includes("(")) { ahref = ahref.split("(")[0]; }
      if (ahref.includes("[")) { ahref = ahref.split("[")[0]; }
      if (!ahref.toLocaleLowerCase().includes("notice to constituents")) {
        if (ahref.includes("to")) { ahref = ahref.split(" to")[0]; }
      }
      if (ahref.includes("through")) { ahref = ahref.split(" through")[0]; }
      if (isNaN(Number(ahref.split("-")[0])) && !ahref.toLocaleLowerCase().includes("notice to constituents") && !ahref.toLocaleLowerCase().includes("maintenance update") && !ahref.toLocaleLowerCase().includes("accounting standards update") && !ahref.toLocaleLowerCase().includes("paragraph not used") && !ahref.toLocaleLowerCase().includes("subsection")) {
        return false;
      }
      //else if (ahref.toLocaleLowerCase().includes("maintenance update") || ahref.toLocaleLowerCase().includes("accounting standards update") || ahref.toLocaleLowerCase().includes(("section")) || ahref.toLocaleLowerCase().includes("subsection")) {
      //  let otherSourceUrlParts = event.target.getAttribute('href').split("/");
      //  event.srcElement.setAttribute("href", "/" + otherSourceUrlParts[1] + "/" + otherSourceUrlParts[2] + "/" + otherSourceUrlParts[otherSourceUrlParts.length - 1]);
      //}
      else if (ahref.toLocaleLowerCase().includes("notice to constituents") || ahref.toLocaleLowerCase().includes("paragraph not used")) {
        let otherSourceUrlParts = event.target.getAttribute('href').split("/");
        event.srcElement.setAttribute("href", "/" + otherSourceUrlParts[1] + "/" + otherSourceUrlParts[2] + "/noticeToConstituents");
      }
      else if (ahref.includes("-") && ahref.split("-").length >= 2) {
        let navPath = event.target.innerText.split("-");
        let url = this.getBreadcrumbWithNavPath(navPath[0] + "-" + navPath[1] + "-" + navPath[2]);
        event.srcElement.setAttribute("href", "/" + url + "/" + ahref);
      }
      else {
        let otherSourceUrlParts = event.target.getAttribute('href').split("/");
        let otherSourceUrlLastPart = event.target.getAttribute('href').includes('#') ? event.target.getAttribute('href').split('#')[1] : otherSourceUrlParts[otherSourceUrlParts.length - 1];
        event.srcElement.setAttribute("href", "/" + otherSourceUrlParts[1] + "/" + otherSourceUrlParts[2] + "/" + otherSourceUrlLastPart);
      }
    }
    else if (event.target.className.includes("term")) {
      event.srcElement.parentElement.removeAttribute("href");
      event.srcElement.parentElement.className = event.srcElement.parentElement.className.includes("cursor-pointer") ? event.srcElement.parentElement.className : event.srcElement.parentElement.className + " cursor-pointer";
    }
  }

  navPathTreeCall$: Subscription;
  mouseOverFunctions(event: any) {
    if (event.srcElement.tagName.toLowerCase() == "a" && event.srcElement.className.toLowerCase() == "ditamap") {
      let ahref = event.srcElement.innerText;
      let navPath = ahref.split("-");
      if (navPath.length >= 3) {
        let tempData = JSON.parse(localStorage.getItem("leftNavigationMenu"));
        if (tempData != undefined && tempData != null) {
          if (navPath[0].includes("Section ")) {
            navPath[0] = navPath[0].replace("Section ", "");
          }
          let navPathUrl: string = this.getBreadcrumbWithNavPath(navPath[0] + "-" + navPath[1] + "-" + navPath[2]);
          event.srcElement.setAttribute("href", "/" + navPathUrl.split("/")[0] + "/" + navPathUrl.split("/")[1] + "/" + navPath[0] + "-" + navPath[1] + "-" + navPath[2]);
        }
        else {
          this.navPathTreeCall$ = this.graphQLService.getNavPathTree(navPath[0] + "-" + navPath[1] + "-" + navPath[2]).subscribe(data => { event.srcElement.setAttribute("href", "/" + data[0].itemLink.split("/")[0] + "/" + data[0].itemLink.split("/")[1] + "/" + ahref); });
        }
      }
      else {
        event.srcElement.setAttribute("href", "/" + ahref + "/tableOfContent");
      }
    }
  }

  getsnum(val) {
    //console.log(this.dita);
    //const parser = new DOMParser();
    //const parsedHtml = parser.parseFromString(val, 'text/html');
    const ariaSname = val.getAttribute('aria-sname');
    const ariaSnumber = val.getAttribute('aria-snumber');
    const dataObject = {
      ariaSname,
      ariaSnumber
    };
    return (dataObject);
  }

  addImage() {
    //let article = document.getElementById(this.paraArticleId);
    //if (article != null) {
    let ImageDivs = document.getElementsByClassName("img") as HTMLCollectionOf<HTMLImageElement>;
    if (ImageDivs.length > 0) {
      for (let i = 0; i < ImageDivs.length; i++) {
        if (!ImageDivs[i].hasAttribute("style")) {
          let hasStyle = ImageDivs[i].getAttribute("style");
          if (hasStyle == null) {
            ImageDivs[i].onload = function () {
              ImageDivs[i].style.width = String(ImageDivs[i].naturalWidth) + "px";
              ImageDivs[i].style.height = String(ImageDivs[i].naturalHeight) + "px";
              ImageDivs[i].style.maxHeight = '100%';
              ImageDivs[i].style.maxWidth = '100%';
              ImageDivs[i].style.boxSizing = 'border-box';
            }
          }
        }
      }
    }
    /*}*/
  }

  openLinkById(event, paraNum, pageurl, pageNums) {
    let path: any = event.composedPath() as Array<any>;
    event.preventDefault();
    let notUsedLink = path.find(p => p.tagName && p.tagName.toLowerCase() === 'a' && p.className == "xref NotUsed");
    if (!notUsedLink) {
      //let firstAnchor = path.find(p => p.tagName && p.tagName.toLowerCase() === 'a' && p.className == "xref");
      this.commonDataService.showAllPageUrlClicked.next(pageurl);
      this.commonDataService.paraNumClicked.next(paraNum);
      this.linkClicked(event, paraNum, pageurl, pageNums);
      let linktopdf = path.find(p => p.tagName && p.tagName.toLowerCase() === 'span');
      if (linktopdf && linktopdf.hasAttribute('aria-sname') && linktopdf.hasAttribute('aria-snumber')) {
        let data = this.getsnum(linktopdf);

        let s1 = data['ariaSname'];
        let s2 = data['ariaSnumber'];

        this.loginService.getsname(s2, s1).subscribe((x: any) => {
          window.open(x.link);
        });

      }




    }
    else {
      let href = notUsedLink.getAttribute('href');
      this.router.navigateByUrl(href.split('/')[1] + "/" + href.split('/')[2] + "/noticeToConstituents");
    }
  }

  url: string = "";
  linkClicked(event, paraNum, pageurl, pageNums) {
    let path: any = event.composedPath() as Array<any>;
    event.preventDefault();
    let firstAnchor = path.find(p => p.tagName && p.tagName.toLowerCase() === 'a' && p.className == "xref");
    let ditamap = path.find(p => p.tagName && p.tagName.toLowerCase() === 'a' && p.className == "ditamap");
    if (firstAnchor && !firstAnchor.hasAttribute('routerrlink')) {
      let href = firstAnchor.getAttribute('href');
      let otherSourceUrlParts = href.split("/");
      let otherSourceUrlLastPart = href.includes('#') ? href.split('#')[1] : otherSourceUrlParts[otherSourceUrlParts.length - 1];
      let pageHeading = document.getElementById("pageHeading");
      let secPageHeading = document.getElementById("pageHeadingSec");
      if (((pageHeading != null || secPageHeading != null || window.location.href.includes("showallinonepage") || window.location.href.includes("showallinonepageplus")) && (pageHeading?.innerHTML?.toLocaleLowerCase().includes("glossary") || secPageHeading?.innerHTML?.toLocaleLowerCase().includes("glossary") || window.location.href.includes("showallinonepage")) && isNaN(Number(firstAnchor.innerText.split("-")[0])) && !firstAnchor.innerText.toLocaleLowerCase().includes(("Accounting Standards Update").toLocaleLowerCase())
        && !firstAnchor.innerText.toLocaleLowerCase().includes(("Maintenance Update").toLocaleLowerCase()) && !firstAnchor.innerText.toLocaleLowerCase().includes(("html").toLocaleLowerCase()) && !firstAnchor.innerText.toLocaleLowerCase().includes(("subsection").toLocaleLowerCase())
        && !firstAnchor.innerText.toLocaleLowerCase().includes(("example").toLocaleLowerCase()) && !firstAnchor.innerText.toLocaleLowerCase().includes(("paragraph").toLocaleLowerCase()))) {
        // this.router.navigateByUrl("MasterGlossary");
        // this.commonDataService.glossaryTerm.next(firstAnchor.innerText);
        this.commonDataService.glossaryTermId.next(otherSourceUrlLastPart);
        this.commonDataService.showRightPanel.next(true);
        this.commonDataService.rightOverlayOption.next("inline-glossary");
        this.commonDataService.rightPanelWidth.next("rightOverLay_small");
      }
      else if (firstAnchor.innerText.toLocaleLowerCase().includes("maintenance update") || firstAnchor.innerText.toLocaleLowerCase().includes("accounting standards update") || firstAnchor.innerText.toLocaleLowerCase().includes(("section")) || firstAnchor.innerText.toLocaleLowerCase().includes("subsection")) {
        let otherSourceUrlParts1 = event.target.getAttribute('href').split("/");
        let otherSourceUrlLastPart = event.target.getAttribute('href').includes('#') ? event.target.getAttribute('href').split('#')[1] : otherSourceUrlParts[otherSourceUrlParts.length - 1];
        this.router.navigateByUrl(otherSourceUrlParts1[1] + "/" + otherSourceUrlParts1[2] + "/" + otherSourceUrlLastPart);
      }
      else if (firstAnchor.innerText.toLocaleLowerCase().includes("notice to constituents")) {
        let otherSourceUrlParts2 = event.target.getAttribute('href').split("/");
        this.router.navigateByUrl(otherSourceUrlParts2[1] + "/" + otherSourceUrlParts2[2] + "/noticeToConstituents");
      }
      else {
        let firstAnchorInnerText = "";
        if (firstAnchor.innerText.includes("(")) {
          firstAnchorInnerText = firstAnchor.innerText.split("(")[0];
        }
        if (firstAnchor.innerText.includes("[")) {
          firstAnchorInnerText = firstAnchor.innerText.split("[")[0];
        }
        if (firstAnchor.innerText.includes("to")) {
          firstAnchorInnerText = firstAnchorInnerText != "" ? firstAnchorInnerText.split(" to")[0] : firstAnchor.innerText.split(" to")[0]
        }
        if (firstAnchor.innerText.includes("through")) {
          firstAnchorInnerText = firstAnchorInnerText != "" ? firstAnchorInnerText.split(" through")[0] : firstAnchor.innerText.split(" through")[0];
        }
        firstAnchorInnerText = firstAnchorInnerText != "" ? firstAnchorInnerText : firstAnchor.innerText;
        if ((!this.router.url.includes("showallinonepage") && (!this.router.url.includes("showallinonepageplus") && (this.router.url.split("/")[2] != otherSourceUrlParts[2])) || ((this.router.url.includes("showallinonepage") || this.router.url.includes("showallinonepageplus")) && (this.url.split("/")[1] != otherSourceUrlParts[2])))) {
          if (firstAnchorInnerText.includes("-") && firstAnchorInnerText.split("-").length >= 2) {
            if ((pageNums != firstAnchorInnerText.split("-")[0] + "-" + firstAnchorInnerText.split("-")[1] + "-" + firstAnchorInnerText.split("-")[2]) &&
              (pageNums != firstAnchorInnerText.split("-")[1] + "-" + firstAnchorInnerText.split("-")[0] + "-" + firstAnchorInnerText.split("-")[2])) {
              let navSplit = firstAnchorInnerText.split("-");
              let url = this.getBreadcrumbWithNavPath(navSplit[0] + "-" + navSplit[1] + "-" + navSplit[2]);
              let otherSourceUrl = "/" + url + "/" + firstAnchorInnerText;
              this.router.navigate([otherSourceUrl]);
            }
            else {
              if (firstAnchorInnerText.includes("-")) {
                let firstAnchornode = document.getElementById(firstAnchorInnerText);
                if (pageNums == firstAnchorInnerText.split("-")[1] + "-" + firstAnchorInnerText.split("-")[0] + "-" + firstAnchorInnerText.split("-")[2]) {
                  if (firstAnchorInnerText.split("-").length == 4) {
                    firstAnchorInnerText = firstAnchorInnerText.split("-")[1] + "-" + firstAnchorInnerText.split("-")[0] + "-" + firstAnchorInnerText.split("-")[2] + "-" + firstAnchorInnerText.split("-")[3]
                  } else {
                    firstAnchorInnerText = firstAnchorInnerText.split("-")[1] + "-" + firstAnchorInnerText.split("-")[0] + "-" + firstAnchorInnerText.split("-")[2]
                  }
                  firstAnchornode = document.getElementById(firstAnchorInnerText);
                }
                let historyData = {};
                let url: string = "";
                if (this.router.url.includes("-") && this.router.url.split("-").length >= 2) {

                  let navSplit = this.router.url.split("/")[this.router.url.split("/").length - 1].split("-");
                  let urlFetched = this.getBreadcrumbWithNavPath(navSplit[0] + "-" + navSplit[1] + "-" + navSplit[2]);
                  url = urlFetched + "/" + firstAnchorInnerText;
                }
                else {
                  url = this.router.url + "/" + firstAnchorInnerText;
                }
                history.pushState(historyData, "scrollUrl", url);
                this.RetainInPagePosition(firstAnchornode, url);
              }
              else {
                var otherSourceUrlPartsnode = document.getElementById(otherSourceUrlParts[otherSourceUrlParts.length - 1]);
                scrollIntoView(otherSourceUrlPartsnode, {
                  scrollMode: 'always',
                  block: 'start',
                  inline: 'start',
                  boundary: document.getElementsByTagName('app-main-content')[0]
                })
              }
            }
          }
          else {
            let otherSourceUrl = "/" + otherSourceUrlParts[1] + "/" + otherSourceUrlParts[2] + "/" + otherSourceUrlLastPart;
            this.router.navigate([otherSourceUrl]);
          }
        }
        else {
          if (firstAnchor.innerText.includes("-")) {
            let firstAnchornode = document.getElementById(firstAnchorInnerText);
            if (pageNums == firstAnchorInnerText.split("-")[1] + "-" + firstAnchorInnerText.split("-")[0] + "-" + firstAnchorInnerText.split("-")[2]) {
              if (firstAnchorInnerText.split("-").length == 4) {
                firstAnchorInnerText = firstAnchorInnerText.split("-")[1] + "-" + firstAnchorInnerText.split("-")[0] + "-" + firstAnchorInnerText.split("-")[2] + "-" + firstAnchorInnerText.split("-")[3]
              } else {
                firstAnchorInnerText = firstAnchorInnerText.split("-")[1] + "-" + firstAnchorInnerText.split("-")[0] + "-" + firstAnchorInnerText.split("-")[2]
              }
              firstAnchornode = document.getElementById(firstAnchorInnerText);
            }
            let historyData = {};
            let url: string = "";
            if (this.router.url.includes("-") && this.router.url.split("-").length >= 2) {

              let navSplit = this.router.url.split("/")[this.router.url.split("/").length - 1].split("-");
              let urlFetched = this.getBreadcrumbWithNavPath(navSplit[0] + "-" + navSplit[1] + "-" + navSplit[2]);
              url = urlFetched + "/" + firstAnchorInnerText;
            }
            else {
              url = this.router.url + "/" + firstAnchorInnerText;
            }
            history.pushState(historyData, "scrollUrl", url);
            this.RetainInPagePosition(firstAnchornode, url);
          }
          else {
            var otherSourceUrlPartsnode1 = document.getElementById(otherSourceUrlParts[otherSourceUrlParts.length - 1]);
            scrollIntoView(otherSourceUrlPartsnode1, {
              scrollMode: 'always',
              block: 'start',
              inline: 'start',
              boundary: document.getElementsByTagName('app-main-content')[0]
            })
          }
        }
      }
    }
    else if (ditamap != null) {
      let navPath = ditamap.innerText.split("-");
      if (navPath.length >= 3) {
        let navPathUrl: string = "";
        let tempData = JSON.parse(localStorage.getItem("leftNavigationMenu"));
        if (tempData != undefined && tempData != null) {
          if (navPath[0].includes("Section ")) {
            navPath[0] = navPath[0].replace("Section ", "");
          }
          navPathUrl = this.getBreadcrumbWithNavPath(navPath[0] + "-" + navPath[1] + "-" + navPath[2]);
        }
        else {
          this.navPathTreeCall$ = this.graphQLService.getNavPathTree(navPath[0] + "-" + navPath[1] + "-" + navPath[2]).subscribe(data => { navPathUrl = data; });
        }
        if (this.router.url.split("/")[2] != navPathUrl.split("/")[1]) {
          this.router.navigateByUrl(navPathUrl + "/" + navPath[0] + "-" + navPath[1] + "-" + navPath[2]);
        }
        else {
          var ditamapnode = document.getElementById(ditamap.innerText);
          scrollIntoView(ditamapnode, {
            scrollMode: 'always',
            block: 'start',
            inline: 'start',
            boundary: document.getElementsByTagName('app-main-content')[0]
          })
        }
      }
      else {
        this.router.navigateByUrl("/" + ditamap.innerText + "/tableOfContent");
      }
    }
    else {
      this.openLinkByIdInternal(event);
    }
  }

  openLinkByIdInternal(event, isSitesBucket = false) {
    let id = event.target.getAttribute('id');
    let glossary_term_class = event?.target?.className;

    if (id !== null) {
      if (id.trim()[0] === '/') {
        if (id.includes("helppendingcontent")) {
          this.commonDataService.showRightPanel.next(true);
          this.commonDataService.rightOverlayOption.next("helppendingcontent");
          this.commonDataService.rightPanelWidth.next("rightOverlay_large");
        }
        else {
          this.router.navigateByUrl(id);
        }
      }
      else if ((id.includes('.')) && (id.split('.').pop() === 'pdf')) {

        let url = '/layoutComponents/getPdf?isSitesBucket=' + isSitesBucket + '&fileName=' + id;//show pdf
        window.open(url);

      }
      else if (id.includes('http')) {
        window.open(id);
      }
      else if (glossary_term_class == "term") {
        this.commonDataService.glossaryTermId.next("");
        if (id != "" && id != null) {
          this.commonDataService.glossaryTermId.next(id);
          this.commonDataService.showRightPanel.next(true);
          this.commonDataService.rightOverlayOption.next("inline-glossary");
          this.commonDataService.rightPanelWidth.next("rightOverLay_small");
          if (this.router.url == "/crossreference") {
            this.commonDataService.glossaryFromCrossReference.next(true);
            this.commonDataService.NavigatingFromComponent.next("ContentPage");
            this.commonDataService.childComponent.next(true);
          }
          else if (this.router.url == "/pendingcontentsystem" || this.router.url == "/pendingcontentintegeration") {
            this.commonDataService.NavigatingFromComponent.next("PendingContentviewer");
            this.commonDataService.childComponent.next(true);
          }
          else {
            this.commonDataService.glossaryFromCrossReference.next(false);
          }
        }
      }
    }
  }
  RetainInPagePosition(firstAnchornode, url) {
    url = url.startsWith("/") ? url.substring(1) : url;
    let top = document.getElementsByTagName('app-main-content')[0]?.scrollTop;
    let height = document.getElementsByTagName('app-main-content')[0]?.scrollHeight;
    let scrollDataArray = JSON.parse(sessionStorage.getItem('inPageScrollPositionRetentionData'));
    let lastUrl = sessionStorage.getItem('inPageScrollLastUrl') == null ? this.router.url : sessionStorage.getItem('inPageScrollLastUrl');
    lastUrl = lastUrl.startsWith("/") ? lastUrl.substring(1) : lastUrl;
    let currentPosition = sessionStorage.getItem('inPageScrollCurrentNum') == null ? -1 : parseInt(sessionStorage.getItem('inPageScrollCurrentNum'));
    if (scrollDataArray == null) { scrollDataArray = []; }
    if (currentPosition == null) { currentPosition = -1; }
    if (top != undefined && height != undefined) {
      if (scrollDataArray.length == currentPosition + 1) {
        if (scrollDataArray[currentPosition] != undefined && scrollDataArray[currentPosition]?.url == lastUrl) {
          scrollDataArray[currentPosition].scrollHeight = height;
          scrollDataArray[currentPosition].scrollTop = top;
        } else {
          scrollDataArray.push({ scrollHeight: height, scrollTop: top, url: lastUrl });
          currentPosition = currentPosition + 1;
        }
        sessionStorage.setItem('inPageScrollPositionRetentionData', JSON.stringify(scrollDataArray));
      }
      else {
        scrollDataArray[currentPosition].scrollHeight = height;
        scrollDataArray[currentPosition].scrollTop = top;
        scrollDataArray[currentPosition].url = lastUrl;
        if (scrollDataArray.length > currentPosition + 1) {
          if (scrollDataArray[currentPosition + 1].url != url) {
            scrollDataArray[currentPosition + 1].url = url;
          }
        }
        sessionStorage.setItem('inPageScrollPositionRetentionData', JSON.stringify(scrollDataArray));
        currentPosition = currentPosition + 1;
      }
      sessionStorage.setItem("inPageScrollLastUrl", url);
      sessionStorage.setItem('inPageScrollCurrentNum', currentPosition.toString());
      scrollIntoView(firstAnchornode, {
        scrollMode: 'always',
        block: 'start',
        inline: 'start',
        boundary: document.getElementsByTagName('app-main-content')[0]
      });
    }
  }

  redirectToGlossaryTermUsage(event) {
    /*if (this.UserInfo.user.roles != "Basic") {*/
    let id = event.target.id;
    this.graphQLService.getInlineGlossaryContent(id).subscribe(glossaryData => {
      if (glossaryData) {
        this.mapGlossaryContent(glossaryData?.hits?.hitsList);
        this.commonDataService.glossaryTermData.next(this.glossaryData);
        this.commonDataService.showRightPanel.next(true);
        this.commonDataService.rightOverlayOption.next("glossary-term-usage");
        this.commonDataService.rightPanelWidth.next("rightOverlay_large");
      }
    })
    //}
    //else {
    //  this.commonDataService.CrossRefReportNotGenerated.next(false);
    //  this.commonDataService.isConfirmationPopUpOpen.next(true);
    //  let dialogRef = this.dialog.open(ConfirmDialogComponent, {
    //    disableClose: true,
    //    width: '600px',
    //    data: constObj.glossaryTermClickForBasic
    //  });
    //}

  }

  contacts: any = [];
  distinctTopics: any = [];
  glossarytopic: any;
  glossaryTitle: any;
  glossaryData: any = {};
  mapGlossaryContent(data) {
    if (data) {
      data.forEach(res => {
        this.glossarytopic = [];
        this.distinctTopics = [];
        this.contacts = [];
        let source = res.source;
        this.glossaryTitle = source.title;
        if (source.usage != null) {
          source.usage.forEach(usage => {
            this.glossarytopic.push(usage)
          });
        }
        let count = 0;
        if (this.glossarytopic.length > 0) {
          this.glossarytopic.forEach(topicRes => {
            if (count == 0) {
              let obj = {
                topic: topicRes.topic,
                topicData: [topicRes]
              }
              this.distinctTopics.push(obj);
              count++;
            }
            else {
              let topics = this.distinctTopics.filter(x => x.topic == topicRes.topic);
              if (topics.length > 0) {
                this.distinctTopics.filter(x => x.topic == topicRes.topic)[0].topicData.push(topicRes);
              }
              else {
                let obj = {
                  topic: topicRes.topic,
                  topicData: [topicRes]
                }
                this.distinctTopics.push(obj);
              }
              count++;
            }
          })
        }
        this.distinctTopics = this.distinctTopics.sort((a, b) => (a.topic < b.topic) ? -1 : 1);
        this.glossarytopic = this.glossarytopic.sort((a, b) => (a.topic < b.topic) ? -1 : 1);
        this.glossaryData = { name: this.glossaryTitle, body: "", topic: this.glossarytopic, seetopic: this.distinctTopics, type: source.glossaryType };
        this.contacts.push(this.glossaryData);
      })
    }
  }

  addPendingContent() {
    let ImageDivs = document.getElementsByClassName("pending-text") as HTMLCollectionOf<HTMLElement>;
    //if (ImageDivs.length == 1) {

    //  let transitionGuidanceNum = ImageDivs[0].getElementsByClassName("xref")[0]?.innerHTML
    //  if (this.PendingContentMerge?.length > 0) {

    //    this.PendingContentMerge.forEach(merge => {
    //      if (merge.para != null) {
    //        var paraswappedList = merge?.para?.split("-");
    //        //console.log(merge?.para.split("-")[1] + "-" + merge?.para.split("-")[0] + "-" + merge?.para.split("-")[2] + "-" + merge?.para.split("-")[3]);
    //        var paraswapped = paraswappedList.length == 4 ? paraswappedList[1] + "-" + paraswappedList[0] + "-" + paraswappedList[2] + "-" + paraswappedList[3] : ""
    //      }
    //      if ((merge.para == this.paraNum || paraswapped == this.paraNum) && merge.transitionGuidance == transitionGuidanceNum) {
    //        if (merge.outofSystemScope == "yes") {
    //          this.highlightParaSolid(article);
    //        }
    //        else {
    //          this.highlightParadotted(article);
    //          if (merge.yesOrNo == "1") {
    //            this.addIntegratedText(article)
    //            this.removeNormData(article);

    //          }
    //          else if (merge.yesOrNo == "2") {
    //            this.removePendingData(article)
    //          }
    //        }
    //      }
    //      else if ((merge.para == this.paraNum || paraswapped == this.paraNum) && merge.transitionGuidance != transitionGuidanceNum && ImageDivs.length > 1) {
    //        ImageDivs[0].remove();
    //      }

    //    })
    //  }

    //}
    //if (ImageDivs.length > 1 && this.PendingContentMerge?.length > 0) {
    //  this.pendingContentDataList = [];
    //  for (let i = 0; i < ImageDivs.length; i++) {
    //    let date = article.getElementsByClassName("p-alphabet") as HTMLCollectionOf<HTMLElement>;
    //    let dateRange = date[i].innerHTML;
    //    let startRange = dateRange.substring(
    //      dateRange.indexOf(")") + 1,
    //      dateRange.lastIndexOf(";")
    //    );
    //    let endRange = dateRange.split("(N)")[1]
    //    let start = this.datePipe.transform(startRange, 'MM/dd/yyyy');
    //    let end = this.datePipe.transform(endRange, 'MM/dd/yyyy');
    //    let transitionGuidanceParaNum = ImageDivs[i].getElementsByClassName("xref")[0]?.innerHTML


    //    if (this.PendingContentMerge?.length > 0) {
    //      let mergeList = this.PendingContentMerge.filter(y => y.transitionGuidance == transitionGuidanceParaNum && (y.para == this.paraNum || (y?.para?.split("-").length == 4 ? (y.para.split("-")[1] + "-" + y?.para.split("-")[0] + "-" + y?.para.split("-")[2] + "-" + y?.para.split("-")[3]) == this.paraNum : "")))[0]
    //      if (mergeList != undefined) {
    //        this.pendingContentDataList.push({ startDate: start, endDate: end, yesOrNo: mergeList.yesOrNo, profileType: mergeList.typeofProfile, transitionGuidanceParaNum: transitionGuidanceParaNum, outofSystemScope: mergeList.outofSystemScope });
    //      }
    //    }
    //  }
    //  if (this.pendingContentDataList.length > 0) { this.handlePendingcontent(this.pendingContentDataList); }

    //}


    if (ImageDivs.length > 0) {
      for (let i = 0; i < ImageDivs.length; i++) {
        if (!ImageDivs[i].className.includes("formatted")) {
          let normText = ImageDivs[i].getElementsByClassName("norm-text") as HTMLCollectionOf<HTMLElement>;
          if (i == 0 && normText.length == 0) {
            ImageDivs[i].className += " mt-0";
          }
          ImageDivs[i].className += " formatted"
          let divBlock = document.createElement("div");
          let img = document.createElement("img");
          img.src = "../../../../assets/icons/clock-black.svg";
          img.alt = "Clock Image";
          img.className = "pending-clock-icon"
          let imgQuestion = document.createElement("img");
          imgQuestion.src = "../../../../assets/icons/Help.svg";
          imgQuestion.alt = "Question Image";
          imgQuestion.className = "pending-question-icon cursor-pointer";
          imgQuestion.id = "/helppendingcontent";
          let textBlock = document.createElement("span");
          textBlock.innerText = "PENDING CONTENT";
          textBlock.className = "mat-Info";
          divBlock.appendChild(img);
          divBlock.appendChild(textBlock);
          divBlock.appendChild(imgQuestion);
          divBlock.className = "bottomMargin";
          ImageDivs[i].insertBefore(divBlock, ImageDivs[i].firstChild);
          let dateSection = ImageDivs[i].getElementsByClassName("date-effective") as HTMLCollectionOf<HTMLElement>;

          if (dateSection.length > 0) {
            for (let j = 0; j < dateSection.length; j++) {
              let divBlock1 = document.createElement("div");
              divBlock1.className = "mt-1rem";
              dateSection[j].insertBefore(divBlock1, dateSection[j].firstChild);
              dateSection[j].innerHTML = dateSection[j].innerHTML.replace("(P)", '<img src="../../../../assets/icons/P-FASB.svg" class="close-nav-icon-right-overlay" alt="Pending FASB P">');
              dateSection[j].innerHTML = dateSection[j].innerHTML.replace("(N)", '<img src="../../../../assets/icons/N-FASB.svg" class="close-nav-icon-right-overlay" alt="Pending FASB N">');

              let guidanceLink = dateSection[j].nextElementSibling;
              if (guidanceLink.tagName.toLowerCase() === 'a' && guidanceLink.className == "xref") {
                guidanceLink.insertAdjacentHTML('afterend', "<div></div>");
              }
            }
          }
        }
      }
    }
  }

}
